import React from 'react';
import styled from 'styled-components';
import { GoHome, GoHeart, GoSearch } from "react-icons/go";
import { RiDashboardLine } from "react-icons/ri";

import { useSpring, animated } from 'react-spring';
import {
  NavLink
} from "react-router-dom";

const CollapseMenu = (props) => {
  const { open } = useSpring({ open: props.navbarState ? 0 : 1 });

  if (props.navbarState === true) {
    return (
      <CollapseWrapper style={{
        transform: open.interpolate({
          range: [0, 0.2, 0.3, 1],
          output: [0, -20, 0, -200],
        }).interpolate(openValue => `translate3d(0, ${openValue}px, 0`),
      }}
      >
        <NavLinks>
          <li><NavLink to="/home" onClick={props.handleNavbar}><GoHome /> Home</NavLink></li>
          <li><NavLink to="/dashboard" onClick={props.handleNavbar}><RiDashboardLine /> Dashboard</NavLink></li>
          <li><NavLink to="/foryou" onClick={props.handleNavbar}><GoHeart /> For You</NavLink></li>
          <li><NavLink to="/explore" onClick={props.handleNavbar}><GoSearch /> Explore</NavLink></li>
        </NavLinks>
      </CollapseWrapper>
    );
  }
  return null;
};

export default CollapseMenu;

const CollapseWrapper = styled(animated.div)`
  z-index: 10000;
  background: #000000;
  position: fixed;
  top: 4.5rem;
  left: 0;
  right: 0;
`;

const NavLinks = styled.ul`
  list-style-type: none;
  padding: 2rem 1rem 2rem 2rem;

  & li {
    transition: all 300ms linear 0s;
  }

  & a {
    font-size: 1.4rem;
    line-height: 2;
    color: #dfe6e9;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #fdcb6e;
      border-bottom: 1px solid #fdcb6e;
    }
  }
`;
